import { Box, CircularProgress } from "@mui/material";

interface LoadingSpinnerProps {
  /** Vertical padding (theme spacing units). */
  py?: number;
  /** Use full viewport height (e.g. protected route gate). */
  fullViewport?: boolean;
}

export default function LoadingSpinner({
  py = 6,
  fullViewport = false,
}: LoadingSpinnerProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: fullViewport ? "center" : undefined,
        py: fullViewport ? 0 : py,
        height: fullViewport ? "100vh" : undefined,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
